import { BID_AGGREGATOR_KEY, BID_AGGREGATOR_PROVIDER } from './environment';

export const optionsCollect = {
  headers: {
    'X-API-Key': BID_AGGREGATOR_KEY,
    'X-RP-Name': BID_AGGREGATOR_PROVIDER,
  },
};
